"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Outputs = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = require("styled-jsx/style");

var _style2 = _interopRequireDefault(_style);

var _react = require("react");

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Outputs = exports.Outputs = function (_React$Component) {
  _inherits(Outputs, _React$Component);

  function Outputs() {
    _classCallCheck(this, Outputs);

    return _possibleConstructorReturn(this, (Outputs.__proto__ || Object.getPrototypeOf(Outputs)).apply(this, arguments));
  }

  _createClass(Outputs, [{
    key: "render",
    value: function render() {
      if (this.props.hidden) {
        return null;
      }

      if (this.props.children) {
        return React.createElement(
          "div",
          {
            className: "jsx-3381935078" + " " + ("outputs" + (this.props.expanded ? " expanded" : ""))
          },
          this.props.children,
          React.createElement(_style2.default, {
            styleId: "3381935078",
            css: ".outputs.jsx-3381935078{padding:10px 10px 10px calc(var(--prompt-width,50px) + 10px);word-wrap:break-word;overflow-y:auto;outline:none;max-height:600px;}.expanded.jsx-3381935078{max-height:100%;}.outputs.jsx-3381935078 a{color:var(--link-color-unvisited,blue);}.outputs.jsx-3381935078 a:visited{color:var(--link-color-visited,blue);}.outputs.jsx-3381935078>div:empty{display:none;}.outputs.jsx-3381935078 code{font-family:\"Source Code Pro\";white-space:pre-wrap;font-size:14px;}.outputs.jsx-3381935078 pre{white-space:pre-wrap;font-size:14px;word-wrap:break-word;}.outputs.jsx-3381935078 img{display:block;max-width:100%;}.outputs.jsx-3381935078 kbd{display:inline-block;border:1px solid #ccc;border-radius:4px;padding:0.1em 0.5em;margin:0 0.2em;box-shadow:0 1px 0px rgba(0,0,0,0.2),0 0 0 2px #fff inset;background-color:#f7f7f7;}.outputs.jsx-3381935078 table{border-collapse:collapse;}.outputs.jsx-3381935078 th,.outputs.jsx-3381935078 td,.outputs.jsx-3381935078 .th,.outputs.jsx-3381935078 .td{padding:0.5em 1em;border:1px solid var(--theme-app-border,#cbcbcb);}.outputs.jsx-3381935078 th{text-align:left;}.outputs.jsx-3381935078 blockquote{padding:0.75em 0.5em 0.75em 1em;background:var(--theme-cell-output-bg,white);border-left:0.5em solid #ddd;}.outputs.jsx-3381935078 .blockquote::before{display:block;height:0;content:\"\u201C\";margin-left:-0.95em;font:italic 400%/1 Open Serif,Georgia,\"Times New Roman\",serif;color:solid var(--theme-app-border,#cbcbcb);}.outputs.jsx-3381935078 blockquote p.jsx-3381935078{display:inline;}.outputs.jsx-3381935078 dd{display:block;-webkit-margin-start:40px;}.outputs.jsx-3381935078 dl{display:block;-webkit-margin-before:1__qem;-webkit-margin-after:1em;-webkit-margin-start:0;-webkit-margin-end:0;}.outputs.jsx-3381935078 dt{display:block;}.outputs.jsx-3381935078 dl{width:100%;overflow:hidden;padding:0;margin:0;}.outputs.jsx-3381935078 dt{font-weight:bold;float:left;width:20%;padding:0;margin:0;}.outputs.jsx-3381935078 dd{float:left;width:80%;padding:0;margin:0;}.outputs.jsx-3381935078 .list-inline li.jsx-3381935078{display:inline;padding-right:20px;text-align:center;}"
          })
        );
      }

      return null;
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return Outputs;
}(React.Component);

Outputs.defaultProps = {
  children: null,
  expanded: false,
  hidden: false
};
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Outputs, "Outputs", "src/components/outputs.js");
  leaveModule(module);
})();

;


//////////////////
// WEBPACK FOOTER
// ./~/@nteract/presentational-components/lib/components/outputs.js
// module id = 122
// module chunks = 186292428941015